import api from '../../api';
import { push } from 'connected-react-router';
import { store as storeNotification } from 'react-notifications-component';
import { socket } from './../store/socket';

const notificationConfig = {
  container: 'top-center',
  animationIn: ['animated', 'fadeIn'],
  animationOut: ['animated', 'fadeOut'],
  dismiss: {
    duration: 1500,
    showIcon: true
  }
};

export const ivrsStartRequest = () => {
  return {
    type: 'IVRS_START_REQUEST'
  };
};

export const ivrsEndRequest = () => {
  return {
    type: 'IVRS_END_REQUEST'
  };
};

export const getAllIVRsSuccess = ({ data }) => {
  return {
    type: 'IVRS_GET_ALL_SUCCESS',
    payload: data
  };
};

export const getAllIVRsError = error => {
  return {
    type: 'IVRS_GET_ALL_ERROR',
    payload: error
  };
};

export const addIVRsSuccess = ({ data }) => {
  return {
    type: 'IVRS_ADD_SUCCESS',
    payload: data
  };
};

export const addIVRsError = error => {
  return {
    type: 'IVRS_ADD_ERROR',
    payload: error
  };
};

export const editIVRsSuccess = ({ data }) => {
  return {
    type: 'IVRS_EDIT_SUCCESS',
    payload: data
  };
};

export const editIVRsError = error => {
  return {
    type: 'IVRS_EDIT_ERROR',
    payload: error
  };
};

export const removeIVRsSuccess = id => {
  return {
    type: 'IVRS_REMOVE_SUCCESS',
    payload: id
  };
};

export const removeIVRsError = error => {
  return {
    type: 'IVRS_REMOVE_ERROR',
    payload: error
  };
};

export const editIVRsOptionsSuccess = ({ data }) => {
  return {
    type: 'IVRS_OPTIONS_EDIT_SUCCESS',
    payload: data
  };
};

export const editIVRsOptionsError = error => {
  return {
    type: 'IVRS_OPTIONS_EDIT_ERROR',
    payload: error
  };
};

export const getAllIVRsOptionsSuccess = ({ data }) => {
  return {
    type: 'IVRS_OPTIONS_GET_ALL_SUCCESS',
    payload: data
  };
};

export const getAllIVRsOptionsError = error => {
  return {
    type: 'IVRS_OPTIONS_GET_ALL_ERROR',
    payload: error
  };
};

export const getAllIVRsConfigSuccess = ({ data }) => {
  return {
    type: 'IVRS_GET_ALL_CONFIG_SUCCESS',
    payload: data
  };
};

export const getAllIVRsConfigError = error => {
  return {
    type: 'IVRS_GET_ALL_CONFIG_ERROR',
    payload: error
  };
};

export const editIVRsConfigSuccess = ({ data }) => {
  return {
    type: 'IVRS_SET_ALL_CONFIG_SUCCESS',
    payload: data
  };
};

export const editIVRsConfigError = error => {
  return {
    type: 'IVRS_SET_ALL_CONFIG_ERROR',
    payload: error
  };
};

export const ivrsModifyStore = ({ data }) => {
  return {
    type: 'IVRS_MODIFY_STORE',
    payload: data
  };
};

export const addIVRs = (data, formReset, submitBtn) => {
  return async dispatch => {
    try {
      submitBtn.disabled = true;
      dispatch(ivrsStartRequest());
      const formData = new FormData();
      Object.keys(data).forEach(key => {
        formData.append(key, data[key] || '');
      });
      const response = await api().post('/api/ivrs', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      dispatch(addIVRsSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'ADD',
        module: 'ivrs',
        data: [response.data]
      });
      formReset();
    } catch (err) {
      dispatch(addIVRsError(err));
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      setTimeout(() => {
        dispatch(ivrsEndRequest());
        submitBtn.disabled = false;
      }, 1800);
    }
  };
};

export const getAllIVRs = (params = {}) => {
  return async dispatch => {
    try {
      dispatch(ivrsStartRequest());
      const response = await api().get('/api/ivrs', { params });
      dispatch(getAllIVRsSuccess(response));
    } catch (err) {
      dispatch(getAllIVRsError(err));
    } finally {
      dispatch(ivrsEndRequest());
    }
  };
};

export const editIVRs = (data, submitBtn = {}) => {
  return async dispatch => {
    const defaultMsg = button => {
      return new Promise(resolve => {
        document
          .getElementsByClassName('page-content')[0]
          .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        setTimeout(() => {
          dispatch(ivrsEndRequest());
          button.disabled = false;
          resolve(true);
        }, 1800);
      });
    };

    try {
      submitBtn.disabled = true;
      dispatch(ivrsStartRequest());
      const id = data._id;
      const response = await api().put('/api/ivrs/' + id, data);
      dispatch(editIVRsSuccess(response));
      await defaultMsg(submitBtn);
      dispatch(push('/ivrs'));
    } catch (err) {
      dispatch(editIVRsError(err));
      await defaultMsg(submitBtn);
    }
  };
};

export const removeIVRs = id => {
  return async dispatch => {
    try {
      dispatch(ivrsStartRequest());
      await api().delete('/api/ivrs/' + id);
      dispatch(removeIVRsSuccess(id));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'REMOVE',
        module: 'ivrs',
        data: id
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'URA removida com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(removeIVRsError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao remover URA.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(ivrsEndRequest());
    }
  };
};

export const editIVRsAudio = (data, submitBtn) => {
  return async dispatch => {
    const defaultMsg = button => {
      return new Promise(resolve => {
        document
          .getElementsByClassName('page-content')[0]
          .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        setTimeout(() => {
          dispatch(ivrsEndRequest());
          button.disabled = false;
          resolve(true);
        }, 1800);
      });
    };

    try {
      submitBtn.disabled = true;
      dispatch(ivrsStartRequest());
      const id = data._id;
      const formData = new FormData();
      Object.keys(data).forEach(key => {
        formData.append(key, data[key]);
      });
      const response = await api().put('/api/ivrs/audio/' + id, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      dispatch(editIVRsSuccess(response));
      await defaultMsg(submitBtn);
      dispatch(push('/ivrs'));
    } catch (err) {
      dispatch(editIVRsError(err));
      await defaultMsg(submitBtn);
    }
  };
};

export const editIVRsOptions = (data, submitBtn = {}, handleModalClose) => {
  return async dispatch => {
    const defaultMsg = button => {
      return new Promise(resolve => {
        document
          .getElementsByClassName('page-content')[0]
          .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        setTimeout(() => {
          dispatch(ivrsEndRequest());
          button.disabled = false;
          resolve(true);
        }, 1800);
      });
    };

    try {
      submitBtn.disabled = true;
      dispatch(ivrsStartRequest());
      const id = data.ivr._id;
      const response = await api().put('/api/ivrs/options/' + id, data);
      dispatch(editIVRsOptionsSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'EDIT',
        module: 'ivrs',
        data: [response.data.ivr]
      });
      await defaultMsg(submitBtn);
      if (handleModalClose) {
        handleModalClose();
      }
    } catch (err) {
      dispatch(editIVRsOptionsError(err));
      await defaultMsg(submitBtn);
    }
  };
};

export const getAllIVRsOptions = (params = {}) => {
  return async dispatch => {
    try {
      dispatch(ivrsStartRequest());
      const response = await api().get('/api/ivrs/options', { params });
      dispatch(getAllIVRsOptionsSuccess(response));
    } catch (err) {
      dispatch(getAllIVRsOptionsError(err));
    } finally {
      dispatch(ivrsEndRequest());
    }
  };
};

export const getAllIVRsConfig = (params = {}) => {
  return async dispatch => {
    try {
      dispatch(ivrsStartRequest());
      const response = await api().get('/api/ivrs/sip_params', { params });
      dispatch(getAllIVRsConfigSuccess(response));
    } catch (err) {
      dispatch(getAllIVRsConfigError(err));
    } finally {
      dispatch(ivrsEndRequest());
    }
  };
};

export const editIVRsConfig = (data, submitBtn) => {
  return async dispatch => {
    const defaultMsg = button => {
      return new Promise(resolve => {
        document
          .getElementsByClassName('page-content')[0]
          .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        setTimeout(() => {
          dispatch(ivrsEndRequest());
          button.disabled = false;
          resolve(true);
        }, 1800);
      });
    };

    try {
      submitBtn.disabled = true;
      dispatch(ivrsStartRequest());
      const response = await api().put('/api/ivrs/sip_params', data);
      dispatch(editIVRsConfigSuccess(response));
      await defaultMsg(submitBtn);
    } catch (err) {
      dispatch(editIVRsConfigError(err));
      await defaultMsg(submitBtn);
    }
  };
};

export const restoreIVRs = data => {
  return async dispatch => {
    try {
      dispatch(ivrsStartRequest());
      const id = data._id;
      const response = await api().put('/api/ivrs/' + id, data);
      dispatch(editIVRsSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'RESTORE',
        module: 'ivrs',
        data: [response.data]
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'URA restaurada com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(editIVRsError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao restaurar URA.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(ivrsEndRequest());
    }
  };
};
